import { apiAuth, apiResponseType } from ".";

export const getConfigTenants = (): apiResponseType =>
  apiAuth.get("configs");

export const showConfigTenant = (uuid: string): apiResponseType =>
  apiAuth.get(`configs/${uuid}/show`);

export const updateConfigTenant = (
  uuid: string,
  data: { value: string }
): apiResponseType =>
  apiAuth.put(`configs/${uuid}/update`, data);

export interface PixConfigResult {
  pixSicrediActive: boolean;
  pixBtgActive: boolean;
  /** Operadora de Pagamentos / Transferência PIX (devoluções) */
  pixPayoutSicrediActive: boolean;
  pixPayoutBtgActive: boolean;
}

export const getPixOperatorConfig = async (): Promise<PixConfigResult> => {
  try {
    const { data, ok } = await getConfigTenants();
    if (ok && data?.response) {
      const configs = data.response as Array<{ key: string; value: string }>;
      const pixSicredi = configs.find((c) => c.key === "pix_sicredi");
      const pixBtg = configs.find((c) => c.key === "pix_btg");
      const payoutSicredi = configs.find((c) => c.key === "pix_payout_sicredi");
      const payoutBtg = configs.find((c) => c.key === "pix_payout_btg");

      return {
        pixSicrediActive: pixSicredi?.value === "true",
        pixBtgActive: pixBtg?.value === "true",
        pixPayoutSicrediActive: payoutSicredi?.value === "true",
        pixPayoutBtgActive: payoutBtg?.value === "true",
      };
    }
  } catch (error) {
    console.error("Error fetching PIX config:", error);
  }

  return {
    pixSicrediActive: false,
    pixBtgActive: false,
    pixPayoutSicrediActive: false,
    pixPayoutBtgActive: false,
  };
};
